var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app-bar",
    {
      staticClass: "bot-header",
      attrs: { height: "60px", dense: "", fixed: "", app: "" },
    },
    [
      _c(
        "v-menu",
        {
          attrs: { "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-icon",
                    _vm._g(
                      _vm._b(
                        { attrs: { color: "#fff", dark: "" } },
                        "v-icon",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_vm._v("mdi-menu")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "v-list",
            _vm._l(_vm.df.menu, function (item, index) {
              return _c(
                "v-list-item",
                { key: index },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                    1
                  ),
                  _c("v-list-item-title", [
                    _c("a", { attrs: { href: item.href, title: item.text } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(item.text) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("a", { staticClass: "logo", attrs: { href: "/", title: "Home" } }, [
        _c("img", {
          attrs: {
            src: require("public/images/templates/bot-isaura.png"),
            alt: "logo",
          },
        }),
      ]),
      _c("v-spacer"),
      _vm._l(
        _vm.isAuthen ? _vm.desktop.menu.authen : _vm.desktop.menu.unauthen,
        function (item, index) {
          return _c(
            "span",
            {
              key: index,
              class: Array.isArray(item.children) ? "msub" : "mmain",
            },
            [
              Array.isArray(item.children)
                ? _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      { attrs: { outlined: "", dark: "" } },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { left: "" } }, [
                                      _vm._v(_vm._s(item.icon)),
                                    ]),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(item.text) +
                                        "\n                "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c(
                        "v-list",
                        _vm._l(item.children, function (child, c) {
                          return _c(
                            "v-list-item",
                            {
                              key: c,
                              attrs: { href: child.href, title: child.text },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v(_vm._s(child.icon)),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(child.text) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: {
                        href: item.href,
                        title: item.text,
                        dark: "",
                        text: _vm.ua.headers.pageKey !== item.pageKey,
                        outlined: _vm.ua.headers.pageKey === item.pageKey,
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v(_vm._s(item.icon)),
                      ]),
                      _vm._v(
                        "\n            " + _vm._s(item.text) + "\n        "
                      ),
                    ],
                    1
                  ),
            ],
            1
          )
        }
      ),
      _c("v-spacer"),
      _vm.isAuthen
        ? _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-avatar",
                          _vm._g(_vm._b({}, "v-avatar", attrs, false), on),
                          [
                            _c("img", {
                              attrs: {
                                src: _vm.ua.member.Avatar,
                                alt: _vm.ua.member.MemberName,
                              },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                775625646
              ),
            },
            [
              _c(
                "v-list",
                _vm._l(_vm.desktop.menu.avatar, function (item, index) {
                  return _c(
                    "v-list-item",
                    { key: index },
                    [
                      _c("v-list-item-title", [
                        _c(
                          "a",
                          { attrs: { href: item.href, title: item.text } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.text) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    href: "/authen/password/forgot",
                    title: "Quên mật khẩu",
                    color: "#fff",
                    text: "",
                  },
                },
                [_vm._v("\n            Quên mật khẩu\n        ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    href: "/authen/register",
                    title: "Đăng ký",
                    color: "#fff",
                    text: "",
                  },
                },
                [_vm._v("\n            Đăng ký\n        ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    href: "/authen/login",
                    title: "Đăng nhập",
                    color: "#fff",
                    text: "",
                  },
                },
                [_vm._v("\n            Đăng nhập\n        ")]
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/header/header.menu.vue